import React from 'react';
import Button from "components/CustomButtons/Button.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import { Modal, Form } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import api from "assets/services/api";

function ModalRemoveNfRouting(props) {
    async function handleDeleteStorage(e) {
        e.preventDefault();
        const remove = await api.patch('/routing/remove/nf', {
            id: props.props.id,
            nf: props.props.nf
        });
        if (remove.status === 200) {
            props.getAllRouting();
            props.onHide();
        };
    };
    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Remover Nota Fiscal
                </Modal.Title>
            </Modal.Header>
            <Form onSubmit={handleDeleteStorage}>
                <Modal.Body>
                    <h4> Tem certeza que deseja remover esse nf da rota?</h4>
                </Modal.Body>
                <Modal.Footer>
                    <div className="d-flex justify-content-center">
                        <Button color="success" type="submit">
                            Confirmar
                        </Button>
                    </div>
                </Modal.Footer>
            </Form>
        </Modal>
    );
}

export default ModalRemoveNfRouting;